<template>
  <section>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">
              <dl v-if="!userId">
                <dd>
                  <v-radio-group v-model="param.searchSecMember" row v-on:change="search">
                    <v-radio
                        v-for="(s, idx) in userTypes"
                        :key="idx"
                        :label="s.text"
                        :value="s.value"
                    ></v-radio>
                  </v-radio-group>
                </dd>
              </dl>
              <dl>
                <dd>
                  <v-col sm="12" class="d-flex">

                    <v-select :items="[{text:'Y', value:true}, {text:'N', value:false}]" item-value="value" item-text="text" v-model="param.searchIsAntiGraftLawTarget"
                              dense
                              clearable
                              flat
                              outlined
                              hide-details
                              label="청탁금지법대상 여부"
                              style="padding-right: 10px; max-width: 200px;"
                              @change="search"
                    />
                    <v-select :items="orderTypes" item-value="value" item-text="text" v-model="param.searchState"
                              dense
                              clearable
                              flat
                              outlined
                              hide-details
                              label="상태 검색"
                              style="padding-right: 10px; max-width: 200px;"
                              @change="search"
                    />
                    <v-select :items="searchColumns" item-value="value" item-text="text" v-model="param.searchColumn"
                              dense
                              clearable
                              flat
                              outlined
                              hide-details
                              label="검색 컬럼"
                              style="padding-right: 10px; max-width: 200px;"
                              @change="search"
                    />
                    <v-text-field :label="searchColumnText"
                                  v-model="searchValue"
                                  v-on:keyup.enter="search"
                                  dense clearable flat outlined
                                  style="max-width: 300px;"
                    />

                  </v-col>
                </dd>
              </dl>
            </li>
            <li class="formList">
              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="신청일" :value="searchDate"></date-range-component>
                </dd>
              </dl>
              <dl>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>

              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchShippingDate" label="발주일" :value="searchShippingDate"></date-range-component>
                </dd>
              </dl>
              <dl>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeShippingItem}"
                            @click="selectShippingItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>


            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <div class="tableBtn">
          <ul>
              <li class="tableBtnList">
                <v-btn color="info" depressed dark @click="changeState('STATE_CREATED')">
                  <!--                <v-icon small class="mr-2">mdi mdi-content-save</v-icon>-->
                  신청 대기
                </v-btn>
              </li>
              <li class="tableBtnList">
                <v-btn color="primary" depressed dark @click="changeState('STATE_ORDERED')">
                  <!--                <v-icon small class="mr-2">mdi mdi-content-save</v-icon>-->
                  신청 완료
                </v-btn>
              </li>
              <li class="tableBtnList">
                <v-btn color="error" depressed dark @click="changeState('STATE_CANCELED')">
                  <!--                <v-icon small class="mr-2">mdi mdi-content-save</v-icon>-->
                  신청 취소
                </v-btn>
              </li>
              <li class="tableBtnList">
                <v-btn color="success" depressed dark @click="changeState('STATE_COMPLETED')">
                  <!--                <v-icon small class="mr-2">mdi mdi-content-save</v-icon>-->
                  발주 완료
                </v-btn>
              </li>
          </ul>
        </div>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn color="#607d8b" depressed dark @click="excelDownload">
                <v-icon left dark>cloud_download</v-icon>
                엑셀 다운로드
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="orders"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="orderId"
            class="elevation-1"
            :footer-props="{showFirstLastPage: true, 'items-per-page-options' : [10,20,50,100,-1]}"
            disable-sort
            show-select
            @click:row="onRowClick"
        >

          <template v-slot:item.user.secManaged="{value}">
            {{ value ? '삼성전자 관리 회원' : '전자사랑 회원' }}
          </template>
          <template v-slot:item.user.antiGraftLawTarget="{value}">
            <span :class="value ? 'red--text' : ''">{{ value ? '대상자' : '비대상' }}</span>
          </template>


          <template v-slot:item.orderState="{value}">
            {{ stateName(value) }}
          </template>

          <template v-slot:item.orderedAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

        </v-data-table>

      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";

import orderApi from '@/api/OrderApi'

// import _ from "lodash";

export default {
  name: "Orders",
  components: {
    'date-range-component': DateRageComponent
  },
  props:{
    id: String,
    userId: String
  },
  data: () => ({
    date: new Date(),
    keywordType: ['아이디', '이름', '닉네임', '휴대폰'],
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    activeShippingItem: null,
    userTypes: [{value: null, text: '전체'}, {value: true, text: '삼성전자 관리 회원'}, {value: false, text: '전자사랑 회원'}],
    orderTypes: [
      {value: null, text: '전체'}
      , {value: 'STATE_CREATED', text: '신청 대기'}
      , {value: 'STATE_ORDERED', text: '신청 완료'}
      , {value: 'STATE_COMPLETED', text: '발주 완료'}
      , {value: 'STATE_CANCELED', text: '신청 취소'}
    ],
    searchColumns: [
        {value: null, text: '전체'},
        {value: 'product.productName', text: '제품명'},
        {value: 'user.name', text: '이름'},
        {value: 'user.retirementDepartment', text: '부서'},
        {value: 'user.retirementPosition', text: '직위'},
        {value: 'user.mobileNo', text: '휴대폰번호'},
        {value: 'name', text: '수령인명'},
        {value: 'mobileNo', text: '배송지 연락처'},
        {value: 'address', text: '배송지 주소'},
        {value: 'addressDetail', text: '배송지 주소 상세'}
    ],
    selected: [],
    headers: [
      {text: '회원구분', value: 'user.secManaged', align: 'left'},
      {text: '이름', value: 'user.name', align: 'left'},
      {text: '직위', value: 'user.retirementPosition', align: 'left'},
      {text: '부서', value: 'user.retirementDepartment', align: 'left'},
      {text: '청탁금지법대상', value: 'user.antiGraftLawTarget', align: 'left'},
      {text: '상태', value: 'orderState'},
      {text: '수령인 이름', value: 'name'},
      {text: '배송지 연락처', value: 'mobileNo'},
      {text: '제품명', value: 'orderProductName'},
      {text: '신청일', value: 'orderedAt'}
    ],
    param: {
      searchSecMember: true,
      keyType: null,
      searchKeyword: null,
      searchColumn: null,
      name: null,
      page: 1
    },
    options: {},
    orders: [],
    totalItems: 0,
    searchDate: [],
    searchShippingDate: [],
    waitingSearch: false,
    searchValue: null,
    all: false
  }),
  computed: {
    searchColumnText() {
      if(this.param.searchColumn) {
        return (this.searchColumns.filter(c => c.value === this.param.searchColumn)?.[0]??{}).text;
      } else {
        return '전체 검색'
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    searchValue: {
      handler(nv) {
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
  },
  methods: {
    changeState(state){
      if(this.selected.length === 0) {
        alert("변경하실 회원을 선택해주세요.")
        return
      }
      if(confirm('선택 하신 회원의 신청 상태를 '+this.stateName(state)+ '로 변경하시겠습니까?')) {
        orderApi.changeState(this.selected.map(o => o.orderId), state).then(data => {
          console.log(data);
          alert('변경되었습니다.');
          this.search();
        });
      }
    },
    stateName(v) {
      return this.orderTypes.find(t => t.value === v)?.text??''
    },
    onRowClick(item) {
      // this.$router.push({path: `/present/orders/${item.orderId}`})
      this.$emit("callback-type", {
        type: 'form',
        orderId:item.orderId
      })
    },
    initSearch() {
      for (const [key] of Object.entries(this.param)) {
        this.param[key] = '';
      }
    },
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      this.search();
    },
    getSearchShippingDate(searchShippingDate = []) {
      this.searchShippingDate = searchShippingDate;
      this.search();
    },
    selectItem(months) {
      this.activeItem = months;
      this.searchDate = [];
      if (this.activeItem !== 0) {
        this.searchDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    selectShippingItem(months) {
      this.activeShippingItem = months;
      this.searchShippingDate = [];
      if (this.activeShippingItem !== 0) {
        this.searchShippingDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchShippingDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    search() {
      const params = this.generateParameters();
      orderApi.list(params).then(data => {
        this.orders = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params)
      });

      this.waitingSearch = false;
    },
    generateParameters() {
      delete this.options.searchKeyword;
      delete this.options.searchSecMember;
      delete this.options.searchDate;
      delete this.options.searchShippingDate;
      delete this.options.searchColumn;
      delete this.options.searchUserId;

      const {  page, itemsPerPage, size } = this.options;

      const params = {...this.param, ...this.options, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if(params.searchDate) {
        this.searchDate = params.searchDate;
      }
      // if (this.activeItem > 0) {
      if (this.searchDate) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }
      params.searchDate = this.searchDate;

      if (this.searchShippingDate) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.startDate = this.searchShippingDate[0];
        params.endDate = this.searchShippingDate[1];
      } else {
        params.startDate = null;
        params.endDate = null;
      }
      params.searchShippingDate = this.searchShippingDate;

      if(params.searchSecMember === 0)
          params.searchSecMember = null;

      params.searchPresentId = this.id;
      params.searchUserId = this.userId;
      return params;
    },
    async excelDownload() {

      const passwd = prompt('엑셀에 설정할 패스워드를 입력하세요.(선택사항)', '');
      const params = this.generateParameters();
      let prefix = this.param.searchSecMember === null ? "전체" : this.param.searchSecMember ? "삼성전자 관리 회원" : "전자사랑 회원";
      let dateName = (this.searchDate && this.searchDate.length > 0) ? params.fromDate + '_' + params.toDate : '';
      const suffix = ((dateName) ? "_" + dateName : '');
      params.excelPassword = passwd;

      await orderApi.excel(params, prefix, suffix);
    }
  },
  created: function () {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
      this.searchValue = this.param.searchKeyword
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 3px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
</style>
